import React, { Fragment, useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { HomeContext } from "./index";
import { getAllCategory } from "../../admin/categories/FetchApi";
import { getAllProduct,} from "../../admin/products/FetchApi"; //productByPrice
import "./style.css";

const apiURL = process.env.REACT_APP_API_URL;

const CategoryList = () => {
  const history = useHistory();
  const { data } = useContext(HomeContext);
  const [categories, setCategories] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      let responseData = await getAllCategory();
      if (responseData && responseData.Categories) {
        setCategories(responseData.Categories);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={`${data.categoryListDropdown ? "block" : "hidden"} mt-4`}>
      <div className="border-t border-gray-200 pt-4">
        <h3 className="text-base font-semibold text-gray-900 mb-3">
          Toutes les catégories
        </h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {categories && categories.length > 0 ? (
            categories.map((item, index) => {
              return (
                <div
                  key={index}
                  onClick={(e) =>
                    history.push(`/products/category/${item._id}`)
                  }
                  className="group cursor-pointer bg-gradient-to-br from-blue-50 to-yellow-50 hover:from-yellow-400 hover:to-yellow-500 rounded-xl p-4 border-2 border-blue-100 hover:border-yellow-600 transition-all duration-300 shadow-md hover:shadow-xl transform hover:-translate-y-1"
                >
                  <div className="flex items-center justify-center">
                    <div className="text-center">
                      <div className="font-bold text-sm md:text-base text-gray-800 group-hover:text-white transition-colors">
                        {item.cName}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-span-full text-center py-6">
              <p className="text-gray-500 text-base">Aucune catégorie disponible</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// const FilterList = () => {
//   const { data, dispatch } = useContext(HomeContext);
//   const [range, setRange] = useState(0);

//   const rangeHandle = (e) => {
//     setRange(e.target.value);
//     fetchData(e.target.value);
//   };

//   const fetchData = async (price) => {
//     if (price === "all") {
//       try {
//         let responseData = await getAllProduct();
//         if (responseData && responseData.Products) {
//           dispatch({ type: "setProducts", payload: responseData.Products });
//         }
//       } catch (error) {
//         console.log(error);
//       }
//     } else {
//       dispatch({ type: "loading", payload: true });
//       try {
//         setTimeout(async () => {
//           let responseData = await productByPrice(price);
//           if (responseData && responseData.Products) {
//             console.log(responseData.Products);
//             dispatch({ type: "setProducts", payload: responseData.Products });
//             dispatch({ type: "loading", payload: false });
//           }
//         }, 700);
//       } catch (error) {
//         console.log(error);
//       }
//     }
//   };

//   const closeFilterBar = () => {
//     fetchData("all");
//     dispatch({ type: "filterListDropdown", payload: !data.filterListDropdown });
//     setRange(0);
//   };

//   return (
//     <div className={`CFA{data.filterListDropdown ? "" : "hidden"} my-4`}>
//       <hr />
//       {/* <div className="w-full flex flex-col">
//         <div className="font-medium py-2">Filter by price</div>
//         <div className="flex justify-between items-center">
//           <div className="flex flex-col space-y-2  w-2/3 lg:w-2/4">
//             <label htmlFor="points" className="text-sm">
//               Prix (Compris entre 5mil and 150mil CFA):{" "}
//               <span className="font-semibold text-yellow-700">{range}.00CFA</span>{" "}
//             </label>
//             <input
//               value={range}
//               className="slider"
//               type="range"
//               id="points"
//               min="5000"
//               max="150000"
//               step="1000"
//               onChange={(e) => rangeHandle(e)}
//             />
//           </div>
//           <div onClick={(e) => closeFilterBar()} className="cursor-pointer">
//             <svg
//               className="w-8 h-8 text-gray-700 hover:bg-gray-200 rounded-full p-1"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M6 18L18 6M6 6l12 12"
//               />
//             </svg>
//           </div>
//         </div>
//       </div> */}
//     </div>
//   );
// };

const Search = () => {
  const { data, dispatch } = useContext(HomeContext);
  const [search, setSearch] = useState("");
  const [productArray, setPa] = useState(null);

  // Fetch all products once when search opens (avoid refetch on every keypress)
  useEffect(() => {
    const fetchAll = async () => {
      dispatch({ type: "loading", payload: true });
      try {
        let responseData = await getAllProduct();
        if (responseData && responseData.Products) {
          setPa(responseData.Products);
        }
      } catch (error) {
        console.log(error);
      } finally {
        dispatch({ type: "loading", payload: false });
      }
    };
    if (data.searchDropdown && !productArray) fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.searchDropdown]);

  const searchHandle = (e) => {
    const value = e.target.value;
    setSearch(value);
    dispatch({
      type: "searchHandleInReducer",
      payload: value,
      productArray: productArray,
    });
  };

  const clearSearch = () => {
    setSearch("");
    dispatch({ type: "setProducts", payload: productArray });
  };

  const closeSearchBar = () => {
    dispatch({ type: "searchDropdown", payload: !data.searchDropdown });
    dispatch({ type: "setProducts", payload: productArray });
    setSearch("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      e.preventDefault();
      closeSearchBar();
    }
  };

  return (
    <div
      className={`${data.searchDropdown ? "block" : "hidden"} mt-4`}
      role="search"
      aria-label="Recherche de produits"
    >
      <div className="border-t border-gray-200 pt-4">
        <div className="flex items-center gap-2">
          <div className="relative flex-1">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <input
              value={search}
              onChange={searchHandle}
              onKeyDown={handleKeyDown}
              className="w-full pl-10 pr-10 py-3 text-sm md:text-base rounded-xl bg-gray-50 border-2 border-gray-200 shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 focus:bg-white placeholder-gray-400 transition-all duration-300"
              type="text"
              placeholder="Rechercher un produit, une marque..."
              aria-label="Rechercher un produit"
              autoFocus
            />
            {search && (
              <button
                onClick={clearSearch}
                aria-label="Effacer la recherche"
                className="absolute inset-y-0 right-2 my-auto h-7 w-7 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-200 transition-all duration-200"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
          <button
            onClick={closeSearchBar}
            className="flex-shrink-0 p-2 rounded-xl text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-all duration-200"
            aria-label="Fermer la recherche"
            title="Fermer (ESC)"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        {search && (
          <div className="mt-2 text-xs md:text-sm text-gray-600">
            <span className="font-medium">Recherche :</span> "{search}"
          </div>
        )}
      </div>
    </div>
  );
};

const ProductCategoryDropdown = (props) => {
  return (
    <Fragment>
      <CategoryList />
      {/* <FilterList /> */}
      <Search />
    </Fragment>
  );
};

export default ProductCategoryDropdown;